// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as LogOutDDefault } from '../../../assets/icons/default/general/log-out-d.svg?react';
import { ReactComponent as LogOutDSolid } from '../../../assets/icons/solid/general/LOG-OUT-D.svg?react';
import { createIcons } from '../../Icon';
const LogOutDIcon = /* @__PURE__ */ createIcons('LogOutD', {
    default: LogOutDDefault,
    solid: LogOutDSolid
});
LogOutDIcon.supportedTypes = ['default', 'solid'];
LogOutDIcon.category = 'general';
export default LogOutDIcon;
